(function () {
    "use strict";

    angular.module("app").component("historyTable", {
        bindings: { history: "<", subjectId: "@" },
        template: `<button type="button" class="btn btn-default" ng-click="$ctrl.ToggleZeroStates()" ng-show="$ctrl.history.length > 0">
                <i class="fa" ng-class="{'fa-eye-slash': !$ctrl.HideZeroStates, 'fa-eye': $ctrl.HideZeroStates }"></i>
                <span i18n="Button_Hide_ZeroStates" ng-if="!$ctrl.HideZeroStates"></span>
                <span i18n="Button_Show_ZeroStates" ng-if="$ctrl.HideZeroStates"></span>
            </button>
            <table class="table table-hover table-striped" id="request-history">
                <thead>
                    <tr>
                        <th></th>
                        <th i18n="Person_role">th>
                        <th i18n="Person_Info_Name"></th>
                        <th i18n="Organisation_Date"></th>
                        <th i18n="Organisation_Status"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="h in $ctrl.history | filter:$ctrl.filter" ng-if="h.FlowStatusDataDto"
                        ng-class="{'current-status': h.Current}">
                        <td><span class="fa fa-lg" ng-class="{'fa-eye': h.Subject === 'Screening', 'fa-file-text-o': h.Subject === 'Request'}"></span></td>
                        <td>{{ h.FlowStatusDataDto.ChangedByRole }}</td>
                        <td>{{ h.FlowStatusDataDto.ChangedBy }}</td>
                        <td>{{ h.DateFrom | utcLocalAdd | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                        <td>{{ h.FlowStatusDataDto.StatusCodeTranslation }}<span ng-if="h.FlowStatusDataDto.Comment"> - {{h.FlowStatusDataDto.Comment}}</span></td>
                    </tr>
                </tbody>
            </table>`,
        controller: function () {
            const vm = this;

            let hideZeroStates = false;

            Object.defineProperty(vm, "HideZeroStates", { get: () => hideZeroStates });

            vm.ToggleZeroStates = function () {
                hideZeroStates = !hideZeroStates;
            };

            vm.filter = function (status) {
                const zeroStatusFiltered = !hideZeroStates || status.StatusCode !== 0;
                if (!vm.subjectId)
                    return zeroStatusFiltered;

                return status.SubjectId == vm.subjectId && zeroStatusFiltered;
            };
        }
    });
})();